export default __webpack_public_path__ + "static/media/deleteBtn.745b8f9b.svg";